import { getIndexerValueForMailboxInfo, type MailboxInfo } from 'owa-client-types';
import type { ConditionalFormattingScenario } from '../store/schema/ConditionalFormattingScenarioType';
import {
    CALENDAR_CONDITIONAL_FORMATTING_SETTING_NAME,
    MAIL_CONDITIONAL_FORMATTING_SETTING_NAME,
} from './constants';
import type { LocalStorageKeys } from 'owa-local-storage';

type ConditionalFormattingSettingNameType =
    | 'calendar_conditionalformatting'
    | 'mail_conditionalformatting';

export function getConditionalFormattingSettingName(
    scenario: ConditionalFormattingScenario
): ConditionalFormattingSettingNameType {
    switch (scenario) {
        case 'Calendar':
            return CALENDAR_CONDITIONAL_FORMATTING_SETTING_NAME;
        case 'Mail':
        default:
            return MAIL_CONDITIONAL_FORMATTING_SETTING_NAME;
    }
}

export function getConditionalFormattingLocalStorageKey(
    mailboxInfo: MailboxInfo,
    scenario: ConditionalFormattingScenario
): LocalStorageKeys {
    const settingName: ConditionalFormattingSettingNameType =
        getConditionalFormattingSettingName(scenario);
    return `${settingName}${getIndexerValueForMailboxInfo(mailboxInfo)}`;
}
